<template>
  <div class="container">
    <dashboardHeader>
    </dashboardHeader>
    <div class="card">
      <div class="card-body">
        <form action="" @submit="checkUserDataForm">
          <div class="row text-left">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="name">Nome</label>
                <input
                  id="name"
                  class="form-control"
                  type="text"
                  v-model="user.name"
                  required
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="document_id">CPF/CNPJ</label>
                <input
                  id="document_id"
                  class="form-control"
                  type="text"
                  v-mask="identifyDocument"
                  v-model="user.document_id"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="zipcode">CEP:</label>
                <input
                  id="zipcode"
                  class="form-control"
                  type="text"
                  v-model="user.zipcode"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="street">Logradouro</label>
                <input
                  id="street"
                  class="form-control"
                  type="text"
                  v-model="user.street"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="street_number">Número</label>
                <input
                  id="street_number"
                  class="form-control"
                  type="text"
                  v-model="user.street_number"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="city">Complemento</label>
                <input
                  id="city"
                  class="form-control"
                  type="text"
                  v-model="user.complement"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="district">Bairro</label>
                <input
                  id="district"
                  class="form-control"
                  type="text"
                  v-model="user.district"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="city">Cidade</label>
                <input
                  id="city"
                  class="form-control"
                  type="text"
                  v-model="user.city"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="state">Estado</label>
                <input
                  id="state"
                  class="form-control"
                  type="text"
                  v-model="user.state"
                />
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div v-if="countries" class="form-group">
                <label for="country">País</label>
                <model-select
                  id="country"
                  style="border: transparent; border-bottom: 1px solid #dddddd; border-radius: 0"
                  :options="countries"
                  v-model="user.country"
                ></model-select>
              </div>
            </div>
            <div class="col-12">
              <p v-if="error" class="error">
                {{ error }}
              </p>
              <input
                class="btn btn-franchise btn-block"
                type="submit"
                value="Salvar"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
export default {
  name: "UserDataPage",
  data() {
    return {
      user: {
        name: null,
        document_id: null,
        document_type: null,
        country: null,
        state: null,
        city: null,
        district: null,
        zipcode: null,
        street: null,
        street_number: null,
        complement: null,
      },
      countries: [],
      error: false,
    };
  },
  components: {
    dashboardHeader: () => import("@/components/molecules/DashboardHeader.vue"),
    ModelSelect,
  },
  mounted() {
    this.user = JSON.parse(localStorage.user);
    this.loadCountries();
  },
  computed: {
    identifyDocument() {
      return (this.user.document_id && this.user.document_id.length <= 14)
        ? "###.###.###-##"
        : "##.###.###/####-##";
    },
  },
  methods: {
    checkUserDataForm(e) {
      this.save();
      e.preventDefault();
    },
    async save() {
      this.error = false;
      let postdata = {
        user: this.user,
      };

      var result = await this.$run_axios("post", "/user/update", postdata);
      if (result) {
        if (result.status == 1) {
          localStorage.user = JSON.stringify(this.user);
          this.$router.push("/dashboard");
        } else {
          this.error = result.message;
        }
      }
    },
    async loadCountries() {
      var result = await this.$run_axios("get", "/country");
      if (result) {
        if (result.status == 1) {
          result.data.forEach((element) => {
            this.countries.push({
              value: element.iso,
              text: element.name,
            });
          });
        } else {
          this.error = result.message;
        }
      }
    },
  },
};
</script>

<style></style>
